'use client';

import middlewares from '@akinon/next/redux/middlewares';
import { listenerMiddleware } from './listener';
import reducers from '@akinon/next/redux/reducers';
import {
  Action,
  AnyAction,
  configureStore,
  Middleware,
  Store,
  ThunkAction,
  ThunkDispatch
} from '@reduxjs/toolkit';
import categoryReducer from '@theme/redux/reducers/category';
import taniReducer from '@theme/redux/reducers/tani';
import categoryMiddleware from '@theme/redux/middlewares/category';
import checkoutStepperReducer from '@theme/redux/reducers/checkoutStepper';
import priceAlertReducer from '@theme/redux/reducers/priceAlert';
import checkoutReducer from '@theme/redux/reducers/agreement';
import installmentOptionsReducer from '@theme/redux/reducers/installmentOptions';
import compareReducer from '@theme/redux/reducers/compare';
import reviewModalReducer from '@theme/redux/reducers/reviewModal';
import headerSearchReducer from '@theme/redux/reducers/headerSearch';

const _middlewares: Middleware[] = [
  listenerMiddleware.middleware,
  ...middlewares,
  categoryMiddleware
];

const _reducers = {
  ...reducers,
  compare: compareReducer,
  category: categoryReducer,
  tani: taniReducer,
  checkoutStepper: checkoutStepperReducer,
  priceAlert: priceAlertReducer,
  checkoutAgreement: checkoutReducer,
  installmentOptions: installmentOptionsReducer,
  reviewModal: reviewModalReducer,
  headerSearch: headerSearchReducer
};

export const makeStore = (): Store<{
  [key in keyof typeof _reducers]: ReturnType<typeof _reducers[key]>;
}> =>
  configureStore({
    reducer: _reducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(_middlewares)
  });

export type AppStore = ReturnType<typeof makeStore>;

export type RootState = ReturnType<AppStore['getState']>;

export type TypedDispatch = ThunkDispatch<RootState, void, AnyAction>;

export type AppDispatch = AppStore['dispatch'];

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const store = makeStore();
